export const css = {
	root: '_1B2qpEMq',
	pressed: '_3GzP-_g4',
	label: '_3lgwMhbj',
	disabled: '_2_LGptoQ',
	' _key': 'afcpe-theme/dojo/outlined-button'
};

export default css;
